import {
    QL_LOADING,
    QL_ERROR,

    QL_HEADERS_GET,
    QL_HEADER_GET_BY_ID,
    QL_HEADER_UPDATE,
    QL_HEADER_DELETE,

    QL_QUESTIONS_GET,
    QL_QUESTION_GET_BY_ID,
    QL_QUESTION_UPDATE,
    QL_QUESTION_DELETE
} from "api/menu/master-files/question-library/actions";

const initialState = {
    loading: false,
    errors: [],

    qlHeaders: [],
    qlHeadersSingle: {},
    qlQuestions: [],
    qlQuestionSingle: {},
};

export default function(state = initialState, action) {
    let qlHeaders,
        qlHeadersSingle,
        qlQuestions,
        qlQuestionSingle,
        index;
    switch (action.type) {
        case QL_ERROR:
            return {
                ...state,
                errors: action.payload
            };
        case QL_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case QL_HEADERS_GET:
            return {
                ...state,
                loading: false,
                qlHeaders: action.payload
            };
        case QL_HEADER_GET_BY_ID:
            return {
                ...state,
                loading: false,
                qlHeadersSingle: action.payload
            };
        case QL_HEADER_UPDATE:
            qlHeaders = Object.assign([], state.qlHeaders);
            index = qlHeaders.findIndex(value => value.id === action.payload.id);
            if (index > -1) {
                qlHeaders[index] = action.payload;
            } else {
                qlHeaders.unshift(action.payload);
            }

            qlHeadersSingle = Object.assign({}, state.qlHeadersSingle);
            if (qlHeadersSingle
                && qlHeadersSingle.id
                && qlHeadersSingle.id === action.payload.id) {
                qlHeadersSingle = action.payload;
            }
            return {
                ...state,
                loading: false,
                qlHeaders,
                qlHeadersSingle
            };
        case QL_HEADER_DELETE:
            qlHeaders = Object.assign([], state.qlHeaders);
            index = qlHeaders.findIndex(value => value.id === action.payload);
            if (index > -1) {
                qlHeaders.splice(index, 1);
            }
            qlHeadersSingle = Object.assign({}, state.qlHeadersSingle);
            if (qlHeadersSingle.id === action.payload) {
                qlHeadersSingle = {};
            }
            return {
                ...state,
                loading: false,
                qlHeaders,
                qlHeadersSingle
            };

        case QL_QUESTIONS_GET:
            return {
                ...state,
                loading: false,
                qlQuestions: action.payload
            };
        case QL_QUESTION_GET_BY_ID:
            return {
                ...state,
                loading: false,
                qlQuestionSingle: action.payload
            };
        case QL_QUESTION_UPDATE:
            qlQuestions = Object.assign([], state.qlQuestions);
            index = qlQuestions.findIndex(value => value.id === action.payload.id);
            if (index > -1) {
                qlQuestions[index] = action.payload;
            } else {
                qlQuestions.unshift(action.payload);
            }

            qlQuestionSingle = Object.assign({}, state.qlQuestionSingle);
            if (qlQuestionSingle
                && qlQuestionSingle.id
                && qlQuestionSingle.id === action.payload.id) {
                qlQuestionSingle = action.payload;
            }
            return {
                ...state,
                loading: false,
                qlQuestions,
                qlQuestionSingle
            };
        case QL_QUESTION_DELETE:
            qlQuestions = Object.assign([], state.qlQuestions);
            index = qlQuestions.findIndex(value => value.id === action.payload);
            if (index > -1) {
                qlQuestions.splice(index, 1);
            }
            qlQuestionSingle = Object.assign({}, state.qlQuestionSingle);
            if (qlQuestionSingle.id === action.payload) {
                qlQuestionSingle = {};
            }
            return {
                ...state,
                loading: false,
                qlQuestions,
                qlQuestionSingle
            };
        default:
            return state;
    }
}
